// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--L9W5Z","text":"_103a151b99--text--MHvV5","attention":"_103a151b99--attention--_jS0q"};